import listedkitService from 'resources/listedkit/listedkit.service';

import * as listedkitOperations from 'resources/listedkit/listedkit.operations';
import * as listedkitHelpers from 'resources/listedkit/listedkit.helpers';

const generateTransactionListedKit = async ({
  deal,
  dealStage,
  milestonesWithTasks,
}) => {
  const milestones = await listedkitOperations.generateMilestonesAndTasks({
    deal,
    milestonesWithTasks,
  });

  const createdListedKit = await listedkitService.createListedKit({
    company_id: deal.company_id,
    milestone_ids: milestones.map((m) => m.id),
    deal_id: deal.id,
    type: listedkitHelpers.getListedKitType(deal.type, dealStage),
  });

  return createdListedKit;
};

export {
  generateTransactionListedKit,
};
